import { Component, Inject, Input, OnInit } from '@angular/core';
import * as moment from "moment";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DataStoreService } from "../../shared/services/api/data-store.service";
import { Observable } from "rxjs";
import { Appointment } from "../../shared/models/appointment";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { NotificationsService } from "angular2-notifications";
import { CustomValidators } from "../../shared/services/CustomValidators";
import { Site } from "../../shared/models/site";

enum State {
  LOADING,
  OK,
  ERROR,
  EMPTY
}

@Component({
  selector: 'app-appointment-create',
  templateUrl: './appointment-create.component.html',
  styleUrls: ['./appointment-create.component.css']
})
export class AppointmentCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
              private dataStore: DataStoreService,
              private dialogRef: MatDialogRef<AppointmentCreateComponent>,
              private notificationService: NotificationsService,
              @Inject(MAT_DIALOG_DATA) private dialogData) {
  }

  form: FormGroup;
  private siteTextControl: FormControl;
  private sites: Site[] = [];
  autoCompletState = State.OK;
  States = State;

  filteredSites: Observable<Site[]> = null;

  @Input() day: any;
  @Input() selectedSite: Site = null;

  ngOnInit() {
    if (this.dialogRef != null) {
      this.day = this.dialogData["day"];
      if (this.dialogData["selectedSite"]) {
        this.selectedSite = this.dialogData["selectedSite"];
      }
    }

    this.form = this.createForm();
    if (this.selectedSite == null) {
      this.initializeAutoComplete();
    }
  }

  private initializeAutoComplete() {
    this.filteredSites = this.siteTextControl.valueChanges
      .startWith(null)
      .distinctUntilChanged()
      .debounceTime(200)
      .filter(val => typeof val == "string")
      .switchMap(val => {
          if (val) {
            this.autoCompletState = State.LOADING;
            return this.dataStore.findAll(Site, {
              filter: {
                query: val
              }
            }).map(doc => doc.getModels());
          } else {
            return [];
          }
        }
      ).do(sites => {
        this.sites.splice(0, this.sites.length);
        this.sites.push(...sites)
        this.autoCompletState = sites.length == 0 ? State.EMPTY : State.OK;
      });


  }

  private createForm() {
    let disabled = this.selectedSite != null;
    this.siteTextControl = this.formBuilder.control({
      value: this.selectedSite ? this.selectedSite : null,
      disabled: disabled
    }, [Validators.required, CustomValidators.oneOf(this.sites)]);
    return this.formBuilder.group({
      "date_time": [this.day.format("YYYY-MM-DDThh:mm"), Validators.required],
      "site": this.siteTextControl,
      "duration": [60],
      "on_site": [true, Validators.required]
    })

  }

  displaySite(site: Site): string {
    return (site != null) ? site.fullName : "";
  }

  submit() {
    if (this.form.valid) {
      let appointment = this.dataStore.createRecord(Appointment);
      this.form.value.date_time = moment(this.form.value.date_time).format('YYYY-MM-DD HH:mm:ss')
      Object.assign(appointment, this.form.value);
      if (this.selectedSite) {
        appointment.site = this.selectedSite;
      }
      appointment.save().subscribe(savedAppointment => {
        this.notificationService.success("Termin erstellt", "es wurde ein neuer Termin erstellt");
        this.dialogRef.close(savedAppointment);
      })
    }
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/appointment/appointment-create/appointment-create.component.ts